"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carboncrop_species = exports.carboncrop_species_list = void 0;
exports.carboncrop_species_list = ['gorse', 'radiata'];
exports.carboncrop_species = [
    {
        key: 'gorse',
        display_name: 'Gorse',
    },
    {
        key: 'radiata',
        display_name: 'Radiata (Old - no longer used)',
    },
];
